/* Avine · recomendación de mercado por geolocalización (ago-2026)
   Patrón oficial Shopify: browsing_context_suggestions + form /localization.
   Banner de un clic; NUNCA redirección forzada (GeoIP no es perfecto,
   VPNs, y el cliente puede querer enviar a otro país). */
(function () {
  if (window.__avineGeo) return;
  window.__avineGeo = true;
  if (!window.Shopify || Shopify.designMode) return;
  if (/preview_theme_id=/.test(location.search)) { /* permitido en preview para QA */ }

  var KEY = 'avine_geo_v1';
  var SERVED = { MX: 1, US: 1, CL: 1, ES: 1 };
  var DAYS_14 = 14 * 24 * 60 * 60 * 1000;

  try {
    var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (saved && Date.now() - saved.t < DAYS_14) return;
  } catch (e) {}

  function remember() {
    try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now() })); } catch (e) {}
  }

  var COPY = {
    en: { msg: 'Looks like you\u2019re shopping from {country}. See prices and shipping for your region?', yes: 'Yes, switch', no: 'Stay here' },
    es: { msg: 'Parece que nos visitas desde {country}. \u00bfVer precios y env\u00edo para tu regi\u00f3n?', yes: 'S\u00ed, cambiar', no: 'Quedarme aqu\u00ed' }
  };

  function show(country, language, countryName) {
    var lang = (language === 'en') ? 'en' : 'es';
    var t = COPY[lang];
    var bar = document.createElement('div');
    bar.id = 'avine-geo-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Region suggestion');
    bar.innerHTML =
      '<span class="avine-geo-msg">' + t.msg.replace('{country}', countryName) + '</span>' +
      '<span class="avine-geo-actions">' +
      '<button type="button" class="avine-geo-yes">' + t.yes + '</button>' +
      '<button type="button" class="avine-geo-no">' + t.no + '</button>' +
      '</span>';
    var css = document.createElement('style');
    css.textContent =
      '#avine-geo-bar{position:fixed;left:12px;right:12px;bottom:12px;z-index:9999;display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;background:#1E6B4E;color:#fff;border-radius:10px;padding:12px 16px;font-family:var(--font-body-family,sans-serif);font-size:13.5px;line-height:1.35;box-shadow:0 6px 24px rgba(15,61,36,.35)}' +
      '#avine-geo-bar .avine-geo-msg{min-width:0;flex:1 1 220px}' +
      '#avine-geo-bar .avine-geo-actions{flex:none;display:flex;gap:8px}' +
      '#avine-geo-bar button{border:0;border-radius:7px;padding:8px 14px;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit}' +
      '#avine-geo-bar .avine-geo-yes{background:#FFC533;color:#1A1A1A}' +
      '#avine-geo-bar .avine-geo-no{background:transparent;color:#fff;text-decoration:underline;font-weight:500}' +
      '@media(max-width:480px){#avine-geo-bar{left:8px;right:8px;bottom:8px;padding:11px 12px;font-size:12.5px}}';
    document.head.appendChild(css);
    document.body.appendChild(bar);

    bar.querySelector('.avine-geo-no').addEventListener('click', function () {
      remember();
      bar.remove();
    });
    bar.querySelector('.avine-geo-yes').addEventListener('click', function () {
      remember();
      var form = document.createElement('form');
      form.method = 'POST';
      form.action = (Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'localization';
      form.hidden = true;
      form.innerHTML =
        '<input name="_method" value="PUT">' +
        '<input name="country_code" value="' + country + '">' +
        (language ? '<input name="language_code" value="' + language + '">' : '') +
        '<input name="return_to" value="' + (location.pathname + location.search).replace(/"/g, '') + '">';
      document.body.appendChild(form);
      form.submit();
    });
  }

  function init() {
    fetch(
      (Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') +
        'browsing_context_suggestions.json' +
        '?country%5Benabled%5D=true' +
        '&country%5Bexclude%5D=' + encodeURIComponent(Shopify.country || '') +
        '&language%5Benabled%5D=true' +
        '&language%5Bexclude%5D=' + encodeURIComponent(Shopify.language || '')
    )
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.suggestions || !data.suggestions.length) return;
        var s = data.suggestions[0].parts || {};
        var c = s.country && s.country.handle;
        if (!c || c === Shopify.country) return;
        if (!SERVED[c]) return; /* sin mercado servido: no invitar a un callejón sin salida */
        var lang = null;
        if (c === 'US') {
          lang = (s.language && s.language.handle) ||
            ((navigator.language || '').toLowerCase().indexOf('es') === 0 ? 'es' : 'en');
          if (lang !== 'en' && lang !== 'es') lang = 'en';
        } else {
          lang = 'es';
        }
        var name = (s.country && s.country.name) || c;
        show(c, lang, name);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
